import { FC, PropsWithChildren, useEffect, useRef, useState } from 'react'
import { cn } from '@wellesley/ui'

type ClickRiseAnimationProps = PropsWithChildren & {
  className?: string
}
export const ClickRiseAnimation: FC<ClickRiseAnimationProps> = ({
  children,
  className,
}) => {
  const [scale, setScale] = useState(1)
  const timersRef = useRef<Array<ReturnType<typeof setTimeout>>>([])

  const triggerBounce = () => {
    timersRef.current.forEach(clearTimeout)
    timersRef.current = []
    setScale(0.9)
    timersRef.current.push(
      setTimeout(() => {
        setScale(1.1)
      }, 110),
    )
    timersRef.current.push(
      setTimeout(() => {
        setScale(1)
      }, 220),
    )
  }

  useEffect(() => {
    return () => {
      timersRef.current.forEach(clearTimeout)
      timersRef.current = []
    }
  }, [])

  return (
    <div
      onMouseDown={triggerBounce}
      style={{
        transform: `scale(${scale})`,
        transition: 'transform 120ms ease-out',
      }}
      className={cn('inline-flex', className)}
    >
      {children}
    </div>
  )
}
